import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from '@material-ui/core'
import React from 'react'
import styles from './styles'
import injectStyles from 'react-jss'

const SmallSection = ({ title, columns, data, classes }) => {
  return (
    <Box className={classes.container}>
      <Box className={classes.titleContainer}>
        <Typography className={classes.title}>{title}</Typography>
      </Box>
      <Table className={classes.table}>
        <TableHead>
          <TableRow>
            {columns.map(item => (
              <TableCell key={item.id} className={classes.tableCell}>
                <Typography className={classes.tableHead}>
                  {item.columnName}
                </Typography>
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow>
            {data &&
              data.map(row =>
                typeof row === 'function' ? (
                  <TableCell className={classes.tableCell}>{row()}</TableCell>
                ) : (
                  <TableCell className={classes.tableCell}>{row}</TableCell>
                ),
              )}
          </TableRow>
        </TableBody>
      </Table>
    </Box>
  )
}

export default injectStyles(styles)(SmallSection)
